/**
 * Frontend-Saison-Tabelle: FMP-Season-IDs pro Wettbewerb und Saisonjahr.
 * Spalten = competition.id (1. BL, 2. BL, DHB-Pokal, Super Cup, Relegation).
 *
 * Die aktive Saison (FEATURE_FLAGS.activeSeasonYear) steuert die Default-Anzeige.
 * CMS-fmpSeasonId dient nur noch als Fallback, wenn kein Map-Eintrag existiert.
 */
export const SEASON_ROWS = [
    /* year = Startjahr der Saison (2025 → 2025/26) */
    { year: 2021, ids: [1079, 1106, 1168, 1213, null] },
    { year: 2022, ids: [1274, 1277, 1488, 1532, null] },
    { year: 2023, ids: [1542, 1544, 1588, 1611, 1646] },
    { year: 2024, ids: [1661, 1662, 1660, 1665, null] },
    { year: 2025, ids: [1709, 1710, 1711, 1712, null] },
    { year: 2026, ids: [1738, 1739, 1741, 1740, null] },
];

export function seasonRowByYear(year) {
    const y = Number(year);
    if (!Number.isFinite(y)) {
        return null;
    }
    return SEASON_ROWS.find((r) => r.year === y) || null;
}

export function seasonRowBySeasonId(fmpSeasonId) {
    if (fmpSeasonId == null || fmpSeasonId === '') {
        return null;
    }
    const id = Number(fmpSeasonId);
    if (!Number.isFinite(id)) {
        return null;
    }
    return SEASON_ROWS.find((r) => r.ids.some((sid) => sid === id)) || null;
}

/**
 * Default-fmpSeasonId für einen Wettbewerb in der aktiven Frontend-Saison.
 * @returns {number|null|undefined} number/null aus der Map; undefined wenn kein Eintrag
 */
export function activeSeasonIdForCompetition(competitionId, activeYear) {
    const row = seasonRowByYear(activeYear);
    if (!row) {
        return undefined;
    }
    const idx = Number(competitionId) - 1;
    if (!Number.isFinite(idx) || idx < 0 || idx >= row.ids.length) {
        return undefined;
    }
    return row.ids[idx];
}

/**
 * Cup/Supercup/Relegation-Season-ID zur gleichen Saison wie die Liga-Season.
 * leagueSeasonId = fmpSeasonId der Liga-Kontextseite (ggf. inkl. UI-Override).
 */
export function transformRelatedSeasonId(leagueSeasonId, otherCompetitionId, fallbackSeasonId) {
    const row = seasonRowBySeasonId(leagueSeasonId);
    if (row) {
        const idx = Number(otherCompetitionId) - 1;
        if (Number.isFinite(idx) && idx >= 0 && idx < row.ids.length) {
            return row.ids[idx];
        }
    }
    return fallbackSeasonId;
}
